import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'frontend_tooling-performance_breakdown-timing';
/**
 * https:&#x2F;&#x2F;docs.google.com&#x2F;document&#x2F;d&#x2F;1zSjvc-A7CbTDu6FZikarbi-KeNh7yIjIHe_fu3hQLSo&#x2F;edit
 */ export function trackFrontendToolingPerformanceBreakdownTiming(Action_Name, Load_Type2, Load_Status3, Data_Fetched4, Images_Painted5, Main_JavaScript_Executed6, Main_Thread_Idle7, Page_Component_Mounted8, Page_Component_Rendered_With_Data9, Page_JavaScript_Executed10, Ready_to_Fetch_Data11, Ready_to_Fetch_Page_JavaScript12, HTML_Started13, UPLT_end_time14) {
    var NextJS15 = arguments.length > 14 && arguments[14] !== void 0 ? arguments[14] : 'false', manualOverrides = arguments.length > 15 ? arguments[15] : void 0;
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: true,
        manualOverrides: manualOverrides,
        parameters: {
            Action_Name: Action_Name,
            Load_Type2: Load_Type2,
            Load_Status3: Load_Status3,
            Data_Fetched4: Data_Fetched4,
            Images_Painted5: Images_Painted5,
            Main_JavaScript_Executed6: Main_JavaScript_Executed6,
            Main_Thread_Idle7: Main_Thread_Idle7,
            Page_Component_Mounted8: Page_Component_Mounted8,
            Page_Component_Rendered_With_Data9: Page_Component_Rendered_With_Data9,
            Page_JavaScript_Executed10: Page_JavaScript_Executed10,
            Ready_to_Fetch_Data11: Ready_to_Fetch_Data11,
            Ready_to_Fetch_Page_JavaScript12: Ready_to_Fetch_Page_JavaScript12,
            HTML_Started13: HTML_Started13,
            UPLT_end_time14: UPLT_end_time14,
            NextJS15: NextJS15
        }
    });
}
